import { Form } from '@webinex/antik';
import * as Yup from 'yup';

export interface CancelAppointmentChatFormProps {
  value: CancelAppointmentChatFormValue;
  onSubmit: (value: CancelAppointmentChatFormValue) => any;
}

const SCHEMA = Yup.object({
  reason: Yup.string().field().nullable().required(),
});

export type CancelAppointmentChatFormValue = Yup.InferType<typeof SCHEMA>;

function _CancelAppointmentChatForm(props: CancelAppointmentChatFormProps) {
  const { value, onSubmit } = props;

  return (
    <Form
      type="formik"
      initialValues={value}
      onSubmit={onSubmit}
      uid={CancelAppointmentChatForm.uid}
      ns="cancelAppointmentChat"
      validationSchema={SCHEMA}
      enableReinitialize
    >
      <Form.Item name="reason" required>
        <Form.TextArea />
      </Form.Item>
    </Form>
  );
}

export const CancelAppointmentChatForm = Object.assign(_CancelAppointmentChatForm, {
  schema: SCHEMA,
  uid: 'cancel-appointment-chat',
  initialValues: {
    reason: null!,
  },
});
